import DashboardIcon from "@mui/icons-material/Dashboard";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import CategoryIcon from "@mui/icons-material/Category";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import SettingsIcon from "@mui/icons-material/Settings";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import WorkIcon from "@mui/icons-material/Work";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';

import { Task, List, Man, ContactPage, Groups,DoorFront,Settings } from "@mui/icons-material";

import {
  CUSTOMER_LIST__ROUTE,
  CUSTOMER_PROFILE_ROUTE,
  DASHBOARD_ROUTE,
  DOCUMENTS_ROUTES,
  EMPLOYEES_ROUTE,
  FINANCIAL_ROUTE,
  FORMS_ROUTE,
  FORM_EDIT_ROUTE,
  FORM_SUBMIT_ROUTE,
  FRONT_OFFICE_ROUTE,
  INQUIRY_LIST,
  SYSTEM_CONFIGS_ROUTES,
  CANDIDATE_FORM_ROUTES,
  CANDIDATE_PROFILE_CREATION,
  CANDIDATE_PROFILE_CREATION_AI,
  CANDIDATE_SHORT_LIST,
  LEAD_LIST_ROUTE,
  JOB_ORDER_ROUTE,
  CVDATA_ROUTE,
  CLIENT_ROUTE,
  CANDIDATE_ROUTE,
  CLIENT_HOME_ROUTE,
  REPORTS_ROUTE
} from "../routes";
import { Form } from "formik";

export const getUserRoutes = (user) => {
  let routes;

  if (user?.role === 1) {
    routes = [
      {
        key: "Dashboard",
        title: "Dashboard",
        name: "dashboard",
        icon: <DashboardIcon />,
        link: DASHBOARD_ROUTE,
      },

      {
        key: "Users",
        title: "User Accounts",
        name: "users",
        icon: <Man/>,
        link: EMPLOYEES_ROUTE,
      },

      // {
      //   key: "Customers",
      //   title: "Candidates",
      //   name: "customers",
      //   icon: <SupervisorAccountIcon />,
      //   link: CUSTOMER_LIST__ROUTE,
      // },
      // {
      //   key: "Candidate Forms",
      //   title: "Candidate Forms",
      //   name: "candidate-forms",
      //   icon: <SupervisorAccountIcon />,
      //   link: CANDIDATE_FORM_ROUTES,
      // },
      // {
      //   key: "Financial Accounts",
      //   name: "finance",
      //   title: "Financial Accounts",
      //   icon: <VideoLibraryIcon />,
      //   link: FINANCIAL_ROUTE,
      // },
      // {
      //   key: "Forms",
      //   title: "Forms",
      //   name: "forms",
      //   icon: '',
      //   link: FORMS_ROUTE,
      // },
      // {
      //   key: "SubmitForm",
      //   title: "Profile Creation",
      //   name: "profile-creation",
      //   icon: <ContactPage/>,
      //   link: FORM_SUBMIT_ROUTE,
      // },
      {
        key: "CVData",
        title: "CV Data",
        name: "cv-data",
        icon: <DocumentScannerIcon/>,
        link: CVDATA_ROUTE,
      },
      {
        key: "ShortList",
        title: "Short List",
        name: "short list",
        icon: <Groups/> ,
        link: CANDIDATE_SHORT_LIST,
      },
      {
        key:"JobOrders",
        title:"Job Orders",
        name:"job-orders",
        icon: <Task/>,
        link:JOB_ORDER_ROUTE
      },
      // {
      //   key: "Form Edits",
      //   title: "Form Edits",
      //   name: "form_edits",
      //   icon: <CategoryIcon />,
      //   link: FORM_EDIT_ROUTE(1),
      // },
      // {
      //   key: "File Uploads",
      //   title: "File Uploads",
      //   name: "files",
      //   icon: <CategoryIcon />,
      //   link: DOCUMENTS_ROUTES,
      // },

      {
        key: "FrontOffice",
        title: "Front Office",
        name: "front-office",
        icon: <DoorFront />,
        link: FRONT_OFFICE_ROUTE,
      },
      {
        key: "InquiryList",
        title: "Registrations",
        name: "inquiry-list",
        icon: <List/>,
        link: INQUIRY_LIST,
      },
       {
        key: "SystemConfigs",
        title: "System Configs",
        name: "system-config",
        icon: <Settings />,
        link: SYSTEM_CONFIGS_ROUTES,
      },
      {
        key:"Reports",
        title:"Reports",
        name:"reports",
        icon: <List/>,
        link:REPORTS_ROUTE
      }
    ];
  } else if(user?.role===4) {
    routes=[
      {
        key:'Client Home',
        title:'Client Home',
        name:'client-home',
        icon:<DashboardIcon/>,
        link:CLIENT_HOME_ROUTE
      },
      {
        key:"JobOrders",
        title:"Job Orders",
        name:"job-orders",
        icon: <Task/>,
        link:JOB_ORDER_ROUTE
      }
    ]
  }else if(user?.role===5) {
    routes=[
      {
        key: "CandidatePortal",
        title: "Candidate Portal",
        name: "candidate-portal",
        icon: <DoorFront />,
        link: CANDIDATE_ROUTE,
      }
    ]
  }
  
  else{

    routes = [
      {
        key: "ProfileCreation",
        title: "Profile Creation",
        name: "profile creation",
        icon: <ContactPage/>,
        link: CANDIDATE_PROFILE_CREATION,
      },
      {
        key: "ProfileCreationAI",
        title: "Profile Creation AI",
        name: "profile creation ai",
        icon: <ContactPage/>,
        link: CANDIDATE_PROFILE_CREATION_AI,
      },
      {
        key: "ShortList",
        title: "Short List",
        name: "short list",
        icon: <Groups/> ,
        link: CANDIDATE_SHORT_LIST,
      },
      {
        key: "CVData",
        title: "CV Data",
        name: "cv-data",
        icon: <DocumentScannerIcon/>,
        link: CVDATA_ROUTE,
      },
      {
        key:"LeadList",
        title:"Lead List",
        name:"lead list",
        icon: <List/>,
        link:LEAD_LIST_ROUTE
      },
      {
        key:"JobOrders",
        title:"Job Orders",
        name:"job-orders",
        icon: <Task/>,
        link:JOB_ORDER_ROUTE
      },
      {
        key: "FrontOffice",
        title: "Front Office",
        name: "front-office",
        icon: <DoorFront />,
        link: FRONT_OFFICE_ROUTE,
      },
      {
        key: "InquiryList",
        title: "Registrations",
        name: "inquiry-list",
        icon: <List/>,
        link: INQUIRY_LIST,
      },
      {
        key: "SystemConfigs",
        title: "System Configs",
        name: "system-config",
        icon: <Settings />,
        link: SYSTEM_CONFIGS_ROUTES,
      },
      {
         key: "Forms",
        title: "Letters",
        name: "forms",
        icon: '',
        link: FORMS_ROUTE,
      },
      {
        key:"Reports",
        title:"Reports",
        name:"reports",
        icon: <List/>,
        link:REPORTS_ROUTE
      }
    ];
  }

  return routes;
};
